// Import the necessary components
import VerofreshRecord from './VerofreshRecord'
class ResourceRestrictionRuleSet extends VerofreshRecord {
}

export default ResourceRestrictionRuleSet
